<template>
  <textarea class="form-control"></textarea>
</template>
<style>
  .note-editor.panel {
    margin-bottom: 0;
  }
</style>

<script>

import 'summernote/dist/summernote'

export default{
  props: {
    value: {
      required: true
    },
    height: {
      type: String
    },
    id: {
      type: String
    },
    airMode: {
      type: Boolean,
      default: true
    },
    toolbar: {
      default: () => [
        // [groupName, [list of button]]
        ['style', ['bold', 'italic', 'underline', 'clear']],
        // ['font', ['strikethrough', 'superscript', 'subscript']],
        // ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']]
        // ['height', ['height']]
      ]
    }
  },
  name: 'Summernote',
  watch: {
    value: function (newVal, oldVal) {
      if (oldVal !== null && oldVal.length === 0) {
        $(this.$el).summernote('code', newVal)
      }
    },
    id: function () {
      $(this.$el).summernote('code', this.value)
    }
  },
  mounted () {
    let config = {
      height: this.height,
      airMode: this.airMode
    }

    let vm = this
    config.callbacks = {
      onInit: function () {
        $(vm.$el).summernote('code', vm.value)
      },
      onChange: function () {
        vm.$emit('input', $(vm.$el).summernote('code'))
      },
      onBlur: function () {
        vm.$emit('change', $(vm.$el).summernote('code'))
      }
    }
    config.toolbar = this.toolbar
    $(this.$el).summernote(config)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/Summernote.vue